import { createSlice } from "@reduxjs/toolkit";

import * as subscriptionServices from "../service/subscriptionServices";

const initialState = {
  isPaymentProcessing: false,
  error: "",

  priceLoading: false,
  priceMonthly: 2.99,
  priceYearly: 29,
};

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState,

  reducers: {
    setIsPaymentProcessing(state, action) {
      state.isPaymentProcessing = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(
        subscriptionServices.fetchCountryPrices.pending,
        (state, action) => {
          state.priceLoading = true;
        }
      )
      .addCase(
        subscriptionServices.fetchCountryPrices.fulfilled,
        (state, action) => {
          state.priceMonthly = action.payload.priceMonthly;
          state.priceYearly = action.payload.priceYearly;
          state.priceLoading = false;
        }
      )
      .addCase(
        subscriptionServices.fetchCountryPrices.rejected,
        (state, action) => {
          state.error = action.error.message;
          state.priceLoading = false;
        }
      );
  },
});

export const { setIsPaymentProcessing } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
